import React from 'react'
import styled, { keyframes } from 'styled-components'
import qs from 'qs'
import { Subscribe } from 'unstated'
import AppContainer from './AppContainer'

import { media } from '../utils/style-utils'

import axios from 'axios'
import SelectBox from './SelectBox'

import logo from '../img/mini-logo-white.svg'
import closer from '../img/menu-close.svg'
import arrow from '../img/arrow-right.svg'

const flyIn = keyframes`
    0% {
      transform: scale(0.75);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
`

const Errors = styled.div`
  text-align: left;
  padding: 1em 2.5em;
  margin-bottom: 2em;
  background-color: #fff;
  border: 3px solid #ff7b7b;
  color: #000;
  font-weight: bold;
`

const Success = styled.div`
  font-size: 24px;
  font-weight: bold;
`

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  bottom: 0;
  z-index: 100;
  background: #000;
  color: #fff;
  text-align: center;

  display: none;

  border: 1rem solid #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${media.tablet`
    border-width: 2.8rem;
  `};

  &.is-open {
    display: block;
    animation: ${flyIn} 240ms ease-in-out;
  }
`

const FormFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100% !important;
  margin-top: 1rem;

  button {
    background: #dbbd6e;
    color: #000000;
    font-weight: bold;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.24em;
    border-radius: 0;
    border: 0;
    padding: 1.2em 2em;
    padding-right: 8em;
    cursor: pointer;
    background-image: url(${arrow});
    background-repeat: no-repeat;
    background-position: center right 2em;
  }
`

const ComboElement = styled.div`
  display: flex;

  > *:last-child {
    flex-grow: 1;
  }

  > *:not(:last-child) {
    margin-right: 8%;
  }
`

const Inner = styled.div`
  padding: 3rem 1.3rem;
  ${media.tablet`
    padding: 5rem;
  `};
`

const Closer = styled.button`
  background: none;
  border-radius: 0;
  position: absolute;
  top: 15px;
  right: 15px;
  border: 0;

  ${media.tablet`
  top: 30px;
  right: 30px;
  `};

  &:focus {
    outline: none;
  }
`

const Form = styled.form`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: left;
  > div {
    width: 100%;
    position: relative;
    font-size: 11px;
    margin-bottom: 2em;
    text-transform: uppercase;
    letter-spacing: 0.2em;

    ${media.tablet`
      width: 48%;
    `};
  }

  label {
    position: absolute;
    display: none;
  }

  textarea,
  input {
    color: inherit;
    width: 100%;
    max-width: 100%;

    border: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);
    padding: 1em 0;
    text-transform: uppercase;
    letter-spacing: 0.2em;

    border-radius: 0;
    background: none;
    font-family: inherit;
    font-size: inherit;
    &:focus {
      border-color: #fff;
      outline: none;

      &::placeholder {
        opacity: 0;
      }
    }
    &::placeholder {
      color: #fff;
    }
  }
`

const Title = styled.h2`
  font-weight: 300;
  letter-spacing: 0.24em;
  line-height: 1.2;
  text-transform: uppercase;
  max-width: 10em;
  margin: 1.2em auto;

  font-size: 1.8rem;

  ${media.tablet`
  font-size: 2.8rem;
  `};
`

const Logo = styled.img`
  width: 77px;
`

const OrderForm = class extends React.Component {
  constructor(props) {
    super(props)

    this.onCountryChange = this.onCountryChange.bind(this)
    this.onRegionChange = this.onRegionChange.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  state = {
    price: '60',
    shippingPrice: '0',
    totalPrice: '0',
    firstName: '',
    lastName: '',
    streetAndNr: '',
    postalCode: '',
    city: '',
    country: '',
    region: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    mailBody: '',
  }

  getShippingPrice() {
    let shippingPrice = 50

    switch (this.state.region) {
      case 'Asia':
      case 'North America':
      case 'South America':
        shippingPrice = 50
        break
      case 'Europe':
        shippingPrice = 25
        break
      case 'Benelux':
        shippingPrice = 15
        break
      case 'Australia':
        shippingPrice = 70
        break
    }

    return shippingPrice
  }

  updateBody() {
    const shippingPrice = this.getShippingPrice()
    const mailBody = `
    price: 60 euro,
    shipping: ${shippingPrice} euro,
    total: ${shippingPrice + this.state.price * 1} euro
    `

    this.setState({
      shippingPrice: shippingPrice,
      totalPrice: `${shippingPrice + this.state.price * 1}`,
      mailBody: mailBody,
    })
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
    this.updateBody()
  }

  onCountryChange(selectedOption) {
    if (!selectedOption) return false
    this.setState({ country: selectedOption })
    this.updateBody()
  }

  onRegionChange(selectedOption) {
    if (!selectedOption) return false
    this.setState({ region: selectedOption })
    this.updateBody()
  }

  onSubmit = e => {
    e.preventDefault()
    const {
      firstName,
      lastName,
      streetAndNr,
      postalCode,
      city,
      country,
      region,
      email,
      phone,
      company,
      message,
      mailBody,
      totalPrice,
      shippingPrice,
      price,
    } = this.state

    // have to use an external library to convert the json stuff to form format
    const post = qs.stringify({
      firstName: firstName,
      lastName: lastName,
      streetAndNr: streetAndNr,
      postalCode: postalCode,
      city: city,
      country: country,
      region: region,
      email: email,
      phone: phone,
      company: company,
      message: message,
      mailBody: mailBody,
      totalPrice: totalPrice,
      price: price,
      shippingPrice: shippingPrice,
    })

    axios.post('https://beta-maintenance.thibaultvanrenne.com', post).then(result => {
      let errors = result.data.errors || null

      // make it an array and squash it
      if (errors) {
        errors = Object.values(errors)
        errors = errors.reduce((acc, val) => acc.concat(val), [])
      }

      this.setState({
        errors: errors,
        success: result.data.status,
      })
    })
  }

  render() {
    const {
      firstName,
      lastName,
      streetAndNr,
      postalCode,
      city,
      country,
      region,
      email,
      phone,
      company,
      message,
      mailBody,
    } = this.state

    const { countries } = this.props

    return (
      <Subscribe to={[AppContainer]}>
        {appContainer => (
          <Wrapper
            className={
              appContainer.state.orderModalIsOpen ? 'is-open' : 'is-closed'
            }
          >
            <Inner>
              <Logo src={logo} alt={'Thibault Van Renne'} />
              <Title>Order your wondercase</Title>

              {this.state.errors &&
                this.state.errors.length > 1 && (
                  <Errors>
                    <ul>
                      {this.state.errors.map(error => (
                        <li key={error}>{error}</li>
                      ))}
                    </ul>
                  </Errors>
                )}

              {this.state.success && (
                <Success>
                  Thank you for ordering! <br />
                  Check your mailbox!
                </Success>
              )}

              {!this.state.success && (
                <Form
                  action="https://beta-maintenance.thibaultvanrenne.com"
                  method="post"
                  onSubmit={this.onSubmit}
                >
                  <div>
                    <label htmlFor="firstName">First name *</label>
                    <input
                      placeholder="First name *"
                      name="firstName"
                      value={firstName}
                      required
                      onChange={this.onChange}
                      type="text"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName">Last name *</label>
                    <input
                      placeholder="Last name *"
                      name="lastName"
                      value={lastName}
                      required
                      onChange={this.onChange}
                      type="text"
                    />
                  </div>

                  <div>
                    <label htmlFor="streetAndNr">Street + nr *</label>
                    <input
                      placeholder="Street + nr *"
                      type="text"
                      name="streetAndNr"
                      required
                      value={streetAndNr}
                      onChange={this.onChange}
                    />
                  </div>
                  <ComboElement>
                    <div>
                      <label htmlFor="postalCode">Postal Code *</label>
                      <input
                        placeholder="Postal Code *"
                        type="text"
                        name="postalCode"
                        required
                        value={postalCode}
                        onChange={this.onChange}
                      />
                    </div>
                    <div>
                      <label htmlFor="city">City *</label>
                      <input
                        placeholder="City *"
                        type="text"
                        name="city"
                        required
                        value={city}
                        onChange={this.onChange}
                      />
                    </div>
                  </ComboElement>
                  <div
                    style={{
                      position: 'relative',
                    }}
                  >
                    <label htmlFor="country">Country *</label>
                    <SelectBox
                      subtle
                      name="country"
                      options={countries.edges.map(item => item.node)}
                      value={country}
                      onChange={this.onCountryChange}
                      placeholder={'Country *'}
                    />
                  </div>
                  <div>
                    <label htmlFor="region">Region *</label>
                    <SelectBox
                      subtle
                      name="region"
                      options={[
                        { name: 'Europe' },
                        { name: 'Benelux' },
                        { name: 'Asia' },
                        { name: 'Australia' },
                        { name: 'North America' },
                        { name: 'South America' },
                      ]}
                      value={region}
                      onChange={this.onRegionChange}
                      placeholder={'Region *'}
                    />
                  </div>
                  <div>
                    <label htmlFor="phone">Phone *</label>
                    <input
                      placeholder="Phone *"
                      type="text"
                      name="phone"
                      required
                      value={phone}
                      onChange={this.onChange}
                    />
                  </div>
                  <div>
                    <label htmlFor="email">Email *</label>
                    <input
                      placeholder="Email *"
                      name="email"
                      value={email}
                      required
                      onChange={this.onChange}
                      type="email"
                    />
                  </div>
                  <div style={{ width: '100%' }}>
                    <label htmlFor="company">Company</label>
                    <input
                      placeholder="Company"
                      type="text"
                      name="company"
                      // required
                      value={company}
                      onChange={this.onChange}
                    />
                  </div>
                  <div
                    style={{
                      width: '100%',
                    }}
                  >
                    <label htmlFor="message">Message</label>
                    <textarea
                      rows="5"
                      placeholder="Message"
                      name="message"
                      value={message}
                      onChange={this.onChange}
                    />
                  </div>
                  <div
                    style={{
                      display: 'none',
                      width: '100%',
                    }}
                  >
                    <textarea
                      rows="5"
                      placeholder="mailBody"
                      name="mailBody"
                      value={mailBody}
                    />
                  </div>
                  {this.state.shippingPrice &&
                    this.state.shippingPrice != '0' && (
                      <FormFooter>
                        <div>
                          TVR Wonder Case: 60&nbsp;euro, Shipping:{' '}
                          {this.state.shippingPrice}&nbsp;euro, Total:{' '}
                          {60 + this.state.shippingPrice * 1}&nbsp;euro
                        </div>
                      </FormFooter>
                    )}
                  <FormFooter>
                    <button type="submit">Order your case</button>
                  </FormFooter>
                </Form>
              )}

              <Closer onClick={appContainer.closeOrderModal}>
                <img src={closer} alt="Close" />
              </Closer>
            </Inner>
          </Wrapper>
        )}
      </Subscribe>
    )
  }
}

export default OrderForm



// WEBPACK FOOTER //
// ./src/components/OrderForm.js